import { createContext, useContext } from 'react';
import type { Editor } from '@tiptap/core';
import { UseEditorOptions } from '@tiptap/react';

export const MarkdownEditorContext = createContext<{
  editor: Editor;
  subscribeToUpdate: (
    id: string,
    callback: UseEditorOptions['onUpdate']
  ) => () => void;
  subscribeToSelectionUpdate: (
    id: string,
    callback: UseEditorOptions['onSelectionUpdate']
  ) => () => void;
}>({
  editor: {} as Editor,
  subscribeToUpdate: () => {
    return () => {};
  },
  subscribeToSelectionUpdate: () => {
    return () => {};
  },
});

export const useMarkdownEditor = () => useContext(MarkdownEditorContext);
